import React, { useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer/PageContainer";
import styled from "styled-components";
import Footer from "../../components/Footer";
import "./disclaimer.css"
import LawyerImg from "../../assets/img/cronje_lawyer.png";
import { useTranslation } from "react-i18next";

const DisclaimerPage = () => {
    const { t, i18n } = useTranslation();

    return (
        <PageContainer>
            <main className="h-full" style={{ minHeight: '100vh', color: '#fff', fontFamily: "Undead Pixel 11, ui-sans-serif" }}>

                <div className="sc-87015bf4-1 fAaXYH">
                    <p className="sc-87015bf4-2 SxuMq">
                        <span className="sc-87015bf4-3 daYkY">Milkit</span> {t("disclaimer_page.text_p1")}
                        <br />
                        <br />
                        {t("disclaimer_page.text_p2")}
                        <br />
                        <br />
                        {t("disclaimer_page.text_p3")}{" "}
                        <span className="sc-87015bf4-3 daYkY">{t("disclaimer_page.text_p4")}</span>
                    </p>
                    <img src={LawyerImg} className="sc-87015bf4-0 dKbEwI" />
                </div>


            </main>
            <Footer />
        </PageContainer>
    );
}

export default DisclaimerPage;
